/**
 * Turning chosen sections into the legal description a title request
 * carries, and keeping them in an order a reader expects.
 *
 * Separate from the modal because the composing is the part worth
 * testing: what reaches Shadowland Title as "the land" is what the
 * title runner works from, and a section silently dropped here is a
 * section nobody runs.
 */

/**
 * Township, range, then section — the order a plat is read in, and the
 * order somebody checking the request against one will go looking.
 *
 * Numeric on the section, so Sec 2 comes before Sec 10 rather than
 * after it, which is what sorting the labels as text would do.
 */
export function sortPickedSections(picked = []) {
  return [...(picked || [])].sort((a, b) => (
    String(a?.township || '').localeCompare(String(b?.township || ''))
    || String(a?.range || '').localeCompare(String(b?.range || ''))
    || (Number(a?.section) || 0) - (Number(b?.section) || 0)
  ));
}

/**
 * The land, as one description.
 *
 * The sections the agent clicked, then whatever they wrote. Both, in
 * that order, because the map can only say WHICH sections and the
 * typing is where "N/2" and "the Smith lot" live — dropping either
 * would send a title runner after the wrong ground.
 *
 * The typed text is kept verbatim. It is the agent's words about land
 * somebody is about to spend hours on, and this is not the place to
 * tidy them.
 */
export function composeLandText(picked = [], typed = '') {
  const sections = sortPickedSections(picked)
    .map((row) => String(row?.label || '').trim())
    .filter(Boolean);
  const written = String(typed || '').trim();
  if (!sections.length) return written;
  const joined = sections.join('; ');
  return written ? `${joined}\n${written}` : joined;
}
